export const DOCUMENT_TYPE_STICKER_PRODUCT = 'commerce.stickerProduct';
export const OBJECT_TYPE_STICKER_TEXT_ELEMENT = 'commerce.stickerTextElement';
export const OBJECT_TYPE_STICKER_PRINT_ELEMENT = 'commerce.stickerPrintElement';
export const OBJECT_TYPE_STICKER_MULTICOLOR_PRINT_ELEMENT =
	'commerce.multicolorStickerPrintElement';
export const OBJECT_TYPE_STICKER_VARIANT = 'commerce.stickerVariant';
